import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import '../styles/PublicNavBar.css';

export default function PublicNavBar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="public-header">
      <div className="container">
        <Link to="/" className="logo">
          <span className="logo-text">Velox AI</span>
        </Link>
        
        {/* Mobile menu button */}
        <button 
          className="mobile-menu-button"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
        
        <nav className={`public-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <NavLink 
            to="/features" 
            className={({ isActive }) => isActive ? 'active' : ''} 
            onClick={closeMobileMenu}
          >
            Features
          </NavLink>
          <NavLink 
            to="/pricing" 
            className={({ isActive }) => isActive ? 'active' : ''} 
            onClick={closeMobileMenu}
          >
            Pricing
          </NavLink>
          <NavLink 
            to="/resources" 
            className={({ isActive }) => isActive ? 'active' : ''} 
            onClick={closeMobileMenu}
          >
            Resources
          </NavLink>
          <NavLink 
            to="/about" 
            className={({ isActive }) => isActive ? 'active' : ''} 
            onClick={closeMobileMenu}
          >
            About
          </NavLink>
          <NavLink 
            to="/contact" 
            className={({ isActive }) => isActive ? 'active' : ''} 
            onClick={closeMobileMenu}
          >
            Contact
          </NavLink>
          <NavLink 
            to="/login" 
            className={({ isActive }) => isActive ? 'active' : ''} 
            onClick={closeMobileMenu}
          >
            Log In
          </NavLink>
        </nav>
        
        {/* Auth buttons hidden - routes still functional for direct URL access */}
        {/* 
        <div className="auth-buttons">
          <Link to="/login" className="btn-login">Log In</Link>
          <Link to="/signup" className="btn-signup">Sign Up</Link>
        </div>
        */}
      </div>
    </header>
  );
} 